import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const SettingsContext = React.createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    try {
      const res = await api.get("/settings");
      setSettings(res.data);
    } catch (e) {
      // fallback defaults
      setSettings({
        restaurant_name: "TULSI",
        tagline: "Authentic Indian meals, made with love",
        phone: "0905344045",
        email: "tulsiindianrestaurant262@gmail.com",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, loading, refresh, setSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => React.useContext(SettingsContext);
